module.exports = __webpack_public_path__ + "static/assets/82c45e5d78720d59f61959e4483b7810.png";